<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container
    v-tabs.y-tabs(v-model="currentTab")
      v-tabs-slider
      v-tab
        v-icon.mr-4(color="success" v-if="currentTab > 0") $yzi-check-circle
        .text-sm.text-none.font-medium 1. Create segment
      v-tab(:class="{ 'tab-disabled': !title.trim().length }")
        v-icon.mr-4(color="success" v-if="currentTab > 1") $yzi-check-circle
        .text-sm.text-none.font-medium 2. Upload CSV
      v-tab(:class="{ 'tab-disabled': currentTab < 2 }")
        v-icon.mr-4(color="success" v-if="currentTab > 2") $yzi-check-circle
        .text-sm.text-none.font-medium 3. Map Fields
      v-tab(:class="{ 'tab-disabled': currentTab < 3 }")
        .text-sm.text-none.font-medium 4. Review
    v-divider
    v-tabs-items.pb-16(v-model="currentTab")
      v-tab-item
        .mt-8
          .text-xl.font-semibold.mb-3 Create segment
          .mb-10 Enter segment name and description below
          segment-name(@click="currentTab = 1" :title.sync="title" :description.sync="description")
      v-tab-item
        upload-csv(:parentFile.sync="inputFile" type="groups" :os="os" @onContinue="onContinueUpload")
      v-tab-item
        template(v-if="mappingResponse && inputFile")
          map-fields(:data="mappingResponse" :inputFile="inputFile" type="groups" :os="os" @onValidate="onValidate" @onMapping="onMapping")
      v-tab-item
        review-import(:data="validateResponse" :inputFile="inputFile" :mapperFormData="mapperFormData" :title="title" :description="description" type="groups" :os="os" @onReupload="onReupload")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SegmentName from './SegmentName.vue'
import UploadCsv from '@/components/module/upload/UploadCsv.vue'
import ReviewImport from '@/components/module/upload/ReviewImport.vue'
import MapFields from '@/components/module/upload/MapFields'

export default {
  props: {
    os: {
      type: String,
      default: null
    }
  },
  components: { 
    ReviewImport,
    MapFields,
    SegmentName,
    UploadCsv
  },
  data: () => ({
    currentTab: 0,
    title: '',
    description: '',
    inputFile: null,
    mappingResponse: null,
    validateResponse: null,
    mapperFormData: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    breadcrumbItems () {
      return [
        { text: 'Segments', disabled: false, href: `/admin/${this.os}/segments` },
        { text: 'New segment by CSV import', disabled: true }
      ]
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onContinueUpload(response) {
      this.currentTab = 2
      this.mappingResponse = response
    },
    onValidate(response) {
      this.validateResponse = response
      this.currentTab = 3
    },
    onMapping(response) {
      this.mapperFormData = response
    },
    onReupload() {
      this.inputFile = null
      this.currentTab = 1
    }
  }
}
</script>
